import React from "react";
import "./modal.css";

export default class ModalToEnable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      data: "",
      statusButton: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    let { record } = this.props;
    if (prevProps.record !== record) {
      this.setState({ show: record.show, data: record.data });
      this.setState({ statusButton: false });
    }
  }

  enableAction(data) {
    let { disableRecord } = this.props;
    this.setState({ statusButton: true });
    disableRecord(data);
  }

  render() {
    let { show, data, statusButton } = this.state;
    let { record } = this.props;

    return (
      <>
        {show && (
          <div
            className="Modal"
            style={{ display: "block" }}
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <span className="custom-title-modal">
                    Registro a desactivar:{" "}
                    <span className="text-capitalize">{data.name}</span>
                  </span>
                </div>
                <div className="modal-body">
                  <button
                    onClick={() =>
                      this.setState({ ...record, show: false })
                    }
                    type="button"
                    className="btn"
                    id="btn-cancel"
                  >
                    Cancelar
                  </button>
                  <button
                    disabled={statusButton}
                    onClick={() => this.enableAction(data)}
                    type="button"
                    className="btn"
                    id="btn-success"
                  >
                    {statusButton ? (
                      <div className="container-spinner-loading pt-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </div>
                    ) : (
                      <p>Desactivar</p>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
